import * as BABYLON from "babylonjs";
import * as _ from "lodash";
import { GeoPoint } from "../core/geoPoint";
import { CountryLoader } from "../dataAccess/countryLoader";
import { Continent } from "../model/continent";
import { Country } from "../model/country";
import { Land, LandLevel } from "../model/land";
import { SubContinent } from "../model/subContinent";

export class CountryService {
    private static _instance: CountryService | null = null;

    continents: Continent[] = [];
    subContinents: SubContinent[] = [];
    countries: Country[] = [];

    static get instance() {
        if (!CountryService._instance) {
            CountryService._instance = new CountryService();
        }
        return CountryService._instance;
    }

    async loadCountries(): Promise<void> {
        this.continents = await CountryLoader.loadContinents("assets/earth/countries.proto.bin");
        this.subContinents = _.flatMap(this.continents, it => it.subContinents);
        this.countries = _.flatMap(this.continents, it => it.countries);

        this.continents.forEach(it => it.computeFocusPositionAndCameraAltitudeFromChildren());
        this.subContinents.forEach(it => it.computeFocusPositionAndCameraAltitudeFromChildren());
    }

    getCountryWithIsoCode(isoCode: string): Country | null {
        return _.find(this.countries, it => it.isoCode == isoCode) || null;
    }

    getCountryAtPosition(position: GeoPoint): Country | null {
        return _.find(this.countries, it => it.containsPoint(position)) || null;
    }

    getLandsVisibleByCamera(level: LandLevel, camera: BABYLON.Camera, horizontalMargin: number = 0, depthMargin: number = 0): Land[] {
        switch (level) {
            case LandLevel.Continent:
                return _.filter(this.continents, it => it.isVisibleByCamera(camera, horizontalMargin, depthMargin));
            case LandLevel.SubContinent:
                return _.filter(this.subContinents, it => it.isVisibleByCamera(camera, horizontalMargin, depthMargin));
            case LandLevel.Country:
                return _.filter(this.countries, it => it.isVisibleByCamera(camera, horizontalMargin, depthMargin));
        }
        return [];
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/services/countryService.ts